import React, { useState, useEffect, Fragment } from 'react';

const Logout = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (localStorage.getItem('token') == null) {
      window.location.replace('https://forecast-front.pages.dev/auth/login');
    } else {
      setLoading(false);
    }
  }, []);

  const handleLogout = e => {
    e.preventDefault();

    fetch('https://stg-agro.globalmet.mx/api/auth/logout/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${localStorage.getItem('token')}`
      }
    })
      .then(res => res.json())
      .then(data => {
        console.log(data);
        localStorage.clear();
        window.location.replace('https://forecast-front.pages.dev/auth/login');
      });
  };

  return (
    <div>
      {loading === false && (
        <Fragment>
          <input type='button' value='Cerrar Sesion' onClick={handleLogout} />
        </Fragment>
      )}
    </div>
  );
};

export default Logout;